import React from 'react';

import ReactDOM from 'react-dom/client';

import { App } from './App';

//Note: React router paths are defined at the top level - here!!
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
